import {jsx as _jsx} from "react/jsx-runtime";import * as RadixDialog from '@radix-ui/react-dialog'
import {forwardRef} from 'react'
import {Close as CloseIcon} from '~/ui/icons'
import {cn} from '../cn'

export const DialogClose = forwardRef


(({className, ...props}, ref) => (
  _jsx(RadixDialog.Close, { asChild: true, children: 
    _jsx('button', {
      ref: ref,
      className: cn(
        'absolute top-4 right-4 inline-flex h-6 w-6 cursor-pointer appearance-none items-center justify-center bg-transparent',
        className
      ),
      'aria-label': "Close",
      ...props,
 children: 
      _jsx(CloseIcon, { className: "text-fg-muted hover:opacity-50" ,} )
    })
  })
))
